import { type PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

import { useCheckPartnerSelfie } from '~domains/profile/entities/documents';

import { ROUTES } from '~shared/config/routes';
import { ErrorScreen } from '~shared/ui/error-screen';
import { Loader } from '~shared/ui/loader';

interface ProfileStateGuardProps {
  shouldBeFilled: boolean;
}

export const ProfileStateGuard = ({
  children,
  shouldBeFilled,
}: PropsWithChildren<ProfileStateGuardProps>) => {
  const { data, isLoading, isError } = useCheckPartnerSelfie();

  if (isError) {
    return <ErrorScreen message="Failed to load profile state info." />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (shouldBeFilled && !data?.clientPortraitExists) {
    return <Navigate to={ROUTES.partner.profile} replace />;
  }

  if (!shouldBeFilled && data?.clientPortraitExists) {
    return <Navigate to={ROUTES.partner.root} replace />;
  }

  return children;
};
